<template>
  <v-dialog v-model="isVisible" :max-width="width">
    <v-card>
      <v-card-text v-if="itemDetail.displayId">
        <v-layout>
          <span class="subheading">案件編號：{{itemDetail.displayId}}</span>
        </v-layout>
        <v-layout>
          <span class="subheading">姓名：{{itemDetail.name}}</span>
        </v-layout>
        <v-layout>
          <v-textarea outline
                      autofocus counter="50" label="案件詢問："
                      v-model="question"></v-textarea>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="showCancel"  class="primary" dark text @click="cancelEvent">取消</v-btn>
        <v-btn class="primary" dark text :loading="saveLoading" :disabled="isSuccess" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>

    <v-divider></v-divider>

    <v-card mt-1>
      <v-progress-linear height="3px"
                         v-show="caseResults.loading" color="primary" indeterminate></v-progress-linear>
      <v-card-title>回覆細項紀錄</v-card-title>
      <div v-for="(item, i) in caseResults.list" :key="i">
        <v-card-text>
          <span v-if="caseResults.list.length === 0">無紀錄</span>
          <v-layout column wrap>
            <v-flex>
             <span class="subheading">
                提問時間：{{item.createdDate}}
              </span>
            </v-flex>
            <v-flex>
               <span>
                 {{item.question}}
              </span>
            </v-flex>
            <v-flex v-if="item.resultDate">
             <span class="subheading">
                回覆時間：{{item.resultDate}}
              </span>
            </v-flex>
            <v-flex v-if="item.result">
               <span>
                 {{item.result}}
              </span>
            </v-flex>
            <v-divider></v-divider>
          </v-layout>
        </v-card-text>
        <v-card-actions v-if="isAdmin && item">
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text v-if="showResultView === false" @click="showResult(item)">填寫回覆</v-btn>
        </v-card-actions>
      </div>
    </v-card>

    <v-card mt-1 v-if="isAdmin && showResultView">
      <v-card-text>
        <v-layout row>
          <v-textarea outline
                      autofocus counter="50" label="案件回覆："
                      v-model="result"></v-textarea>
        </v-layout>
        <v-card-actions>
          <v-btn v-if="showCancel"  class="primary" dark text @click="showResultView= false">取消</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text :loading="saveResultLoading" @click="saveResult">送出回覆</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.content"
                :show-cancel="false"
                @confirmEvent="dialogConfirmEvent"></alert-view>
  </v-dialog>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import MobileDetect from 'mobile-detect';
  import TableView from './TableView';
  import AlertView from '@/components/AlertView';

  const md = new MobileDetect(window.navigator.userAgent);
  export default {
    name: 'QuestionView',
    props: {
      itemDetail: Object,
      visible: Boolean,
      showCancel: Boolean,
    },
    components: {
      TableView,
      AlertView
    },
    data() {
      return {
        showResultView: false,
        isSuccess: false,
        width: md.phone() ? '100%':'70%',
        saveLoading: false,
        messageDialog: {
          visible: false,
          title: '',
          content: '',
        },
        question:'',
        result:'',
        caseResults:{
          loading: false,
          list:[],
        },
        isVisible:false,
        saveResultLoading: false,
        selectQuestion: null,
      }
    },
    watch:{
      visible(value){
        this.isVisible = value;
        if (value === true){
          this.question = '';
          this.result = '';
          this.loadData();
        }
      },
      isVisible(value){
        if(!value)
        {
          this.$emit('closeEvent');
        }
      }
    },
    created() {
      // if(this.visible) {
      //   this.question = '';
      //   this.result = '';
      //   this.loadData();
      // }
    },
    computed:{
      ...mapGetters(['getUserInfo']),
      isAdmin() {
        return this.getUserInfo.authority === 'admin';
      }
    },
    methods:{
      ...mapActions(['saveCaseQuestion','fetchQuestionList','saveCaseResult','saveMultiResult']),
      cancelEvent(){
        this.$emit('cancelEvent');
      },

      async confirmEvent(){
        if (this.question === '') {
          this.showDialog(true, '錯誤','請輸入問題！');
          return;
        }

        if (this.question.length > 300) {
          this.showDialog(true, '錯誤','問題描述不能超過50個字！');
          return;
        }

        this.saveLoading = true;
        const res = await this.saveCaseQuestion({
          caseId: this.itemDetail.caseId,
          displayId: this.itemDetail.displayId,
          name: this.itemDetail.name,
          question: this.question
        });
        const saveResult = res.data;
        console.log(`save question ${JSON.stringify(saveResult)}`);
        this.saveLoading = false;
        if (saveResult && saveResult.statusCode === 0){
          this.$emit('saveSuccessEvent', saveResult);
        } else {
          this.$emit('saveSuccessEvent', saveResult);
        }
      },
      async loadData(){
        this.caseResults.loading = true;
        const res = await this.fetchQuestionList({ searchBy: 'caseId' , searchValue: this.itemDetail.caseId});
        const result = res.data;
        console.log(`result ${JSON.stringify(result)}`);
        if (result.statusCode === 0){
          this.caseResults.list = result.data.list;
          if( this.caseResults.list.length > 0) {
            const caseInfoItem = this.caseResults.list[0];
            console.log(`gapThirdDay $=== ${JSON.stringify(caseInfoItem)}`);
            const unixTime = Math.round(new Date(caseInfoItem.createdDate).getTime()/1000);
            const nowUnixTime = Math.round(Date.now() / 1000);
            const gapThirdDay = (nowUnixTime - unixTime) >= (60 * 60 *24 * 3);
            console.log(`gapThirdDay $=== ${gapThirdDay}`);
            if(!gapThirdDay){
              this.showDialog(true, '提示','【細項已詢問過，是否查詢保人細項】');
            }
          }
        }
        this.caseResults.loading = false;

      },
      showResult(data){
        this.selectQuestion = data;
        this.showResultView = true;
      },
      async saveResult(){
        if (this.result === '') {
          this.showDialog(true, '錯誤','請輸入回覆內容！');
          return;
        }

        if (this.result.length > 300) {
          this.showDialog(true, '錯誤','問題回覆內容不能超過300個字！');
          return;
        }

        this.saveLoading = true;
        const res = await this.saveCaseResult({
          questionId: this.selectQuestion.id,
          result: this.result
        });
        const result = res.data;
        console.log(`save question ${JSON.stringify(result)}`);
        this.saveLoading = false;
        if (result && result.statusCode === 0){
          // this.$emit('saveSuccessEvent', saveResult);
          this.loadData();
          this.showResultView = false;
          this.result = '';
        }
      },
      showDialog(visible, title, content) {
        this.messageDialog.visible = visible;
        this.messageDialog.title = title;
        this.messageDialog.content = content;
      },
      dialogConfirmEvent(){
        this.messageDialog.visible = false;
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuestionView.vue